// Education.js - Education Section Component
import React from 'react';
import nyitLogo from "../Asset/NYIT_logo.png";   
import xjtuLogo from "../Asset/xjtu_logo.png";
import uestcLogo from "../Asset/uestc.jpg";

const Education = () => {
  const education = [
    {
      degree: "Ph.D.",
      major: "Electrical and Computer Engineering",
      school: "New York Institute of Technology",
      location: "New York, USA",
      gpa: "4.0",
      year: "2024–2027",
      link: "https://www.nyit.edu/",
      logo: nyitLogo
    },
    {
      degree: "M.Eng.",
      major: "Information and Communication Engineering",
      school: "Xi'an Jiaotong University",
      location: "Xi'an, China",
      gpa: "3.73",
      year: "2022–2024",
      link: "http://en.xjtu.edu.cn/",
      logo: xjtuLogo
    },
    {
      degree: "B.Sc.",
      major: "Electronic Information Engineering",
      school: "University of Electronic Science and Technology of China",
      location: "Chengdu, China",
      gpa: "4.0",
      year: "2018–2022",
      link: "https://en.uestc.edu.cn/",
      logo: uestcLogo
    }
  ];

  return (
    <section id="education" className="w-full">
      <div className="bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Education</h2>

        <div className="space-y-8">
          {education.map((edu, index) => (
            <div
              key={index}
              className="border-l-4 border-blue-600 pl-6 py-4 hover:bg-gray-50 transition duration-300 rounded-lg"
            >

              {/* TOP ROW: School (left) + Logo (right) */}
              <div className="flex items-center justify-between gap-4">
                {/* School Name with Link */}
                <div>
                  <a 
                    href={edu.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl font-bold text-gray-800 hover:text-blue-600 transition inline-flex items-center gap-2"
                  >
                    {edu.school}
                    <svg 
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>

                  {/* Location */}
                  <p className="text-sm text-gray-500 mt-1">{edu.location}</p>
                </div>

                {/* LOGO ON THE RIGHT — bigger & clean */}
                {edu.logo && (
                  <img 
                    src={edu.logo}
                    alt={`${edu.school} logo`}
                    className="w-28 h-20 md:w-32 md:h-24 object-contain flex-shrink-0"
                  />
                )}
              </div>

              {/* Degree and Major */}
              <div className="mt-3">
                <p className="text-lg font-semibold text-gray-700">
                  {edu.degree} in {edu.major}
                </p>
              </div>

              {/* GPA and Year */}
              <div className="mt-2 flex flex-wrap gap-4 text-sm">
                <span className="inline-flex items-center px-3 py-1 bg-blue-50 text-blue-700 rounded-full font-medium">
                  <svg 
                    className="w-4 h-4 mr-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                  </svg>
                  GPA: {edu.gpa}
                </span>

                <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-700 rounded-full font-medium">
                  <svg 
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  {edu.year}
                </span>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
